import { useCallback } from 'react';
import { auth } from '../firebase';
import { doc, updateDoc, increment, serverTimestamp, getFirestore } from 'firebase/firestore';

const db = getFirestore();

export const useAnalytics = () => {
  const trackChatInteraction = useCallback(async (type, data = {}) => {
    if (!auth.currentUser) return;

    try {
      const analyticsRef = doc(db, 'analytics', auth.currentUser.uid);
      const timestamp = serverTimestamp();

      await updateDoc(analyticsRef, {
        [`${type}_count`]: increment(1),
        last_interaction: timestamp,
        [`last_${type}_time`]: timestamp,
        total_interactions: increment(1),
        ...data
      });
    } catch (error) {
      console.error('Error tracking chat interaction:', error);
    }
  }, []);

  const trackModelUsage = useCallback(async (modelName) => {
    if (!auth.currentUser) return;

    try {
      const analyticsRef = doc(db, 'analytics', auth.currentUser.uid);
      await updateDoc(analyticsRef, {
        [`model_usage.${modelName}`]: increment(1),
        last_model_used: modelName,
        last_model_use_time: serverTimestamp()
      });
    } catch (error) {
      console.error('Error tracking model usage:', error);
    }
  }, []);

  const trackErrorOccurrence = useCallback(async (errorType, errorDetails) => {
    if (!auth.currentUser) return;

    try {
      const analyticsRef = doc(db, 'analytics', auth.currentUser.uid);
      await updateDoc(analyticsRef, {
        [`errors.${errorType}`]: increment(1),
        last_error: {
          type: errorType,
          details: errorDetails,
          timestamp: serverTimestamp()
        }
      });
    } catch (error) {
      console.error('Error tracking error occurrence:', error);
    }
  }, []);

  const trackFeatureUsage = useCallback(async (featureName) => {
    if (!auth.currentUser) return;

    try {
      const analyticsRef = doc(db, 'analytics', auth.currentUser.uid);
      await updateDoc(analyticsRef, {
        [`features.${featureName}`]: increment(1),
        last_feature_used: featureName,
        last_feature_use_time: serverTimestamp()
      });
    } catch (error) {
      console.error('Error tracking feature usage:', error);
    }
  }, []);

  return {
    trackChatInteraction,
    trackModelUsage,
    trackErrorOccurrence,
    trackFeatureUsage
  };
};
